/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import React, { useRef } from "react";
import { sendToSwitch } from "../SwapAndSendSection/SwapAndSendStyle";

export interface ToggleButtonProps {
  toggleButtonText: string;
  checked: boolean;
  visible?: boolean;
  handleOnToggle: () => void;
}

export const ToggleButton: React.FC<ToggleButtonProps> = props => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  if (props.visible === false) {
    return null;
  }
  return (
    <button
      css={sendToSwitch}
      ref={buttonRef}
      onClick={e => {
        e.stopPropagation();
        e.preventDefault();
        props.handleOnToggle();
      }}
    >
      <span role={"button"}>{props.toggleButtonText}</span>
      <ToggleLabel>
        <ToggleCheckbox
          type="checkbox"
          className={"mx-2"}
          checked={props.checked ?? false}
          readOnly
        />
        <span className="slider round" />
      </ToggleLabel>
    </button>
  );
};

// Sub components

const ToggleCheckbox = styled.input`
  margin-left: 0.4rem;
  margin-right: 0.4rem;
`;
export const ToggleLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 36px;
  height: 19px;
  margin-left: 0.4rem;
  margin-right: 0.4rem;
`;
